import { useTranslation } from 'react-i18next';
import React from 'react';
import sanitizeHtml from 'sanitize-html';
import WarningOrangeImg from '@src/assets/icons/warning-orange.svg';

const ContentPopupUnPaidOrder = ({
  keyDescriptionUnPaidOrder,
  isNotConfirmedOrder,
}) => {
  const { t } = useTranslation();
  const keyDescription = isNotConfirmedOrder
    ? 'hasOrderWaitForApprovalDescription'
    : 'hasOrderWaitForConfirmTransferDescription';

  return (
    <div className="pending-order-content">
      <div className="description">
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              t(keyDescriptionUnPaidOrder || keyDescription),
            ),
          }}
        />
      </div>
      <div className="note">
        <img src={WarningOrangeImg} alt="warning" />
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(t('notePendingOrder'), {
              allowedTags: ['a'],
              allowedAttributes: {
                a: ['href', 'target', 'rel', 'style'],
              },
            }),
          }}
        />
      </div>
    </div>
  );
};

export default ContentPopupUnPaidOrder;
